import React from 'react';
import {LanguageProvider} from '@zvne/fe-framework/dist/presentation/language/language-provider';
import {Router} from '@zvne/fe-framework/dist/presentation/navigation/router';
import {themeHrefs} from '@zvne/fe-framework/dist/presentation/theme/theme-hrefs';
import {ThemeProvider} from '@zvne/fe-framework/dist/presentation/theme/theme-provider';
import {AdditionalBreadcrumbsProvider} from '@zvne/fe-framework/dist/presentation/navigation/additional-breadcrumbs';
import {AuthProvider} from './reusable/auth/auth-provider';
import {screenHoc} from './screen-hoc';
import {navigation} from './navigation';
import {useAuth} from './reusable/auth/auth-context';

export function Main() {
    return (
        <LanguageProvider>
            <ThemeProvider themeHrefs={themeHrefs}>
                <AdditionalBreadcrumbsProvider>
                    <AuthProvider>
                        <AuthRouter/>
                    </AuthProvider>
                </AdditionalBreadcrumbsProvider>
            </ThemeProvider>
        </LanguageProvider>
    );
}

function AuthRouter() {
    const auth = useAuth();
    return (
        <Router
            navigation={navigation}
            screenHoc={screenHoc}
            auth={auth}
            browserRouterProps={{
                basename: '/nowcasting'
            }}
        />
    );
}

